export default "__VITE_ASSET__4260b49c__"